import React from "react";
import classes from './linkBlock.module.css';
import SiteLink from "../button/siteLink";

const Modul = (props) => {
    return(
        <div className={classes.modulItem}>
            <img src={props.modul.src} alt="img-module" />
            <h3>{props.modul.title}</h3>
            <p>{props.modul.body}</p>
            <SiteLink title="Подробнее" link={props.modul.link}/>
        </div>
    )
}

export default Modul;